var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21939 1.06167C8.93882 0.784397 8.48653 0.787097 8.20925 1.0677C7.93203 1.34831 7.93467 1.80056 8.21532 2.07784L13.484 7.28404H0.858817C0.464331 7.28404 0.144531 7.60383 0.144531 7.99833C0.144531 8.39283 0.464331 8.71261 0.858817 8.71261H13.4824L8.21532 13.9172C7.93467 14.1945 7.93203 14.6468 8.20925 14.9273C8.48653 15.208 8.93882 15.2106 9.21939 14.9334L15.5958 8.63261C15.9495 8.28311 15.9495 7.71197 15.5958 7.3624L9.21939 1.06167Z",
    fill: "#CAC2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.3fac3e329f96964c34407d5b3c6f8856.svg";
export { ForwardRef as ReactComponent };